import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation
} from '@angular/core';

import { recoverAccountView } from './models/recover-your-account.interface';

@Component({
  selector: 'idp-recover-your-account',
  templateUrl: './recover-your-account.component.html',
  styleUrls: ['./recover-your-account.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class RecoverYourAccountComponent {
  @Input() pageData!: recoverAccountView | undefined | null;
  @Input() emailExpired = false;
  @Input() machCore = false;
  @Output() nextDisplayView: EventEmitter<string> = new EventEmitter<string>();
  @Output() triggerClose = new EventEmitter();

  submit() {
    this.nextDisplayView.emit(this.pageData?.nextDisplayView?.nextViewName);
  }
}
